import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icon from "components/AppIcon";

export default function ResetSuccessMessage() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          navigate("/login-page");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [navigate]);

  const progressPercent = ((3 - countdown) / 3) * 100;

  return (
    <div className="text-center py-4">
      <div className="relative w-20 h-20 mx-auto mb-6">
        <div className="absolute inset-0 rounded-full bg-emerald-500/20 animate-ping opacity-25" />
        <div className="relative w-20 h-20 rounded-full bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center">
          <Icon name="ShieldCheck" size={36} color="#10b981" />
        </div>
      </div>

      <h2 className="text-xl font-bold text-white font-heading mb-2">Password updated!</h2>
      <p className="text-slate-400 text-sm font-body mb-1">
        Your password has been reset successfully.
      </p>
      <p className="text-slate-500 text-xs font-body mb-6">
        You can now sign in with your new password.
      </p>

      {/* Countdown progress */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-xs text-slate-500 font-caption">Redirecting to login</span>
          <span className="text-xs text-teal-400 font-caption font-medium">{countdown}s</span>
        </div>
        <div className="w-full bg-white/5 rounded-full h-1.5 overflow-hidden">
          <div
            className="bg-teal-500 h-1.5 rounded-full transition-all duration-1000 ease-linear"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>

      <Link
        to="/login-page"
        className="inline-flex items-center gap-2 h-11 px-6 rounded-xl bg-primary hover:bg-primary/90 text-white font-semibold text-sm font-caption transition-all duration-200 shadow-lg shadow-teal-900/30"
      >
        <Icon name="LogIn" size={16} />
        Go to Login now
      </Link>
    </div>
  );
}
